export default __webpack_public_path__ + "static/media/bg8.cdb8500e.jpg";